import { PropsWithChildren } from 'react'
import './card-midiakit-home.component.scoped.scss'

interface Props extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  icon?: string
  text: string
  button?: any
}

const CardMidiaKitHomeComponent = ({ className, icon, text, button }: Props) => {
  return (
    <div className={`card-home ${className || ''} display-flex align-items-center justify-content-center text-center`}>
      {icon && <i className={icon} style={{ fontSize: '2rem', marginBottom: '1rem' }} />}
      <span dangerouslySetInnerHTML={{ __html: text }} style={{ fontSize: '1rem', marginBottom: '1rem' }}></span>
      {button}
    </div>
  )
}

export default CardMidiaKitHomeComponent
